import { Navigator } from "../../main_components/navigator.js";
import { ProHeadline } from "../../subcomponents/subcomponents.js";
import Styles from "./contact.module.css";
import { EmailUs } from "./contact_components.js";
export const ContactBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const headlines = [
        "📞 We’re Here for You: Contact Us Anytime!",
        "❓ Have Questions? Reach Out and Connect with Us!",
        "💬 Your Voice Matters: Get in Touch with Us!",
        "🗣 Let’s Talk! Contact Us for Support and Inquiries!",
        "💁 Need Assistance? We're Just a Message Away!",
        "🤝 Connect with Our Team: We’d Love to Hear from You!",
        "💡 Got Ideas? Share Them with Us—Contact Us Today!",
        "👍 Your Feedback is Valued: Reach Out to Us Now!",
        "🤝 Let’s Collaborate: Contact Us for Partnership Opportunities!",
        "👂 We’re Listening: Contact Us with Your Thoughts!"
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Contact Us" }/>
            <main className={ Content }>
                <ProHeadline headlines={ headlines }/>
                <EmailUs />
            </main>
        </main>
    );
};